/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const SyncIcon = /*#__PURE__*/ createSvgIcon(
  'SyncIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <g
            clipPath={`url(#${id}_0)`}
            fillRule="evenodd"
            clipRule="evenodd"
            fill="currentColor"
          >
            <path d="M.56 2.99h1v3.5h3.5v1H.56v-4.5z" />
            <path d="M10 1l.003.5a8.5 8.5 0 018.5 7.556l.994-.112A9.5 9.5 0 0010.001.5a8.99 8.99 0 00-8.689 6.353l.956.294A7.99 7.99 0 019.995 1.5L10 1zM15 12.51h4.5v4.5h-1v-3.5H15v-1z" />
            <path d="M3.693 17.1a9.5 9.5 0 01-3.13-6.044l.994-.111a8.5 8.5 0 008.5 7.555h.006a8 8 0 007.69-5.647l.955.294A9 9 0 0110.06 19.5a9.5 9.5 0 01-6.367-2.4z" />
          </g>
          <defs>
            <clipPath id={`${id}_0`}>
              <path fill="#fff" d="M0 0h20v20H0z" />
            </clipPath>
          </defs>
        </>
      ),
    },
  },
  false
);

export default SyncIcon;
